<template>
	<div class="context-menu">
		<div class="container">
			<div class="title" v-if="title">{{ title }}</div>

			<div v-for="opt in computedOptions" :key="opt.name" class="menu-option"
				@click="opt.action" :class="opt.class || {}" :style="opt.style || {}">
				<span class="icon fa-fw" :class="opt.icon" v-if="opt.icon && opt.icon.match(/^fa\w +.+/)"></span>
				<span class="icon fa-fw icon-md" v-else-if="opt.icon">{{ opt.icon }}</span>

				<span class="text">{{ opt.name }}</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'context-menu',

	props: {
		// Menu options
		options: {
			type: Object | Array,
			required: true
		},

		// Menu title, optional
		title: {
			type: String,
			required: false
		}
	},

	computed: {
		/**
		 * Conform options to a standard format
		 */
		computedOptions() {

			/**
			 * Options are converted in an array of objects
			 * containing:
			 * 
			 * - `name` field
			 * - `link` or `action` field
			 */

			if (this.options instanceof Array)
			{
				return this.options.map((opt) => {

					return {
						name: opt,
						action: () => this.$router.push({name: opt})
					}
				})
			}
			else
			{
				return Object.keys(this.options).map((opt) => {

					return {
						name: opt,
						icon: this.options[opt].icon || null,
						action: typeof this.options[opt] === 'function' ?
								this.options[opt] :
								this.options[opt].action || (() => this.$router.push(this.options[opt].link || this.options[opt]))
					}
				})
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
defaultBackground = dark

.context-menu
	position absolute

	.container
		background-color defaultBackground
		color light

		.title
			padding 0.4em 0.8em
			margin-bottom 0.6em
			border-bottom 1px solid darken(defaultBackground, 20%)

			background-color light
			color dark

			font-size 0.8em
		
		.menu-option
			display flex
			align-items center

			padding 0.6em 0.8em

			cursor pointer

			&:hover
				background-color lighten(defaultBackground, 4%)
			
			.icon
				margin-right 0.5em
				
			.text				
				white-space nowrap
</style>
